import * as angular from 'angular';

interface IGotInventoryScope extends angular.IScope {
    contactUsForm : angular.IFormController;
    wasSuccessful : boolean;
    hadError : boolean;
    errorMessage : string;
    contactUs : {
        type : string;
        name : string;
        phone : string;
        email : string;
        message : string;
        reason : string;
    };
}

class GotInventoryCtrl {
    static $inject : string[] = [ '$scope', '$http', 'domain', '$timeout' ];

    constructor(private $scope : IGotInventoryScope,
                private $http : angular.IHttpService,
                private domain : string,
                private $timeout : angular.ITimeoutService) {

        this.$scope.hadError      = false;
        this.$scope.wasSuccessful = false;
    }


    submitContact($event : angular.IAngularEvent) {
        if (!this.$scope.contactUsForm.$valid) {
            $event.preventDefault();

            let errors = [];

            for (let key in this.$scope.contactUsForm.$error) {
                for (let index = 0; index < this.$scope.contactUsForm.$error[ key ].length; index ++) {
                    errors.push(this.$scope.contactUsForm.$error[ key ][ index ].$name + ' is invalid.');
                }
            }

            if (errors.length > 0) {
                this.$scope.wasSuccessful = false;
                this.$scope.hadError      = true;
                this.$scope.errorMessage  = errors[ 0 ];
            }
            return;
        } else {
            this.$scope.contactUsForm.$setPristine();
            this.$scope.contactUsForm.$setUntouched();
        }

        this.$http({
                       method  : 'POST',
                       url: `${this.domain}/api/contactus`,
                       data    : this.$scope.contactUs,
                       headers : {
                           'Content-type' : 'application/json'
                       }
                   })
            .then(() => {
                this.$scope.contactUs.type = undefined;
                this.$scope.contactUs.reason = undefined;
                this.$scope.contactUs.name    = undefined;
                this.$scope.contactUs.phone   = undefined;
                this.$scope.contactUs.email   = undefined;
                this.$scope.contactUs.message = undefined;

                this.$scope.contactUsForm.$setUntouched();
                this.$scope.contactUsForm.$setPristine();

                this.$scope.wasSuccessful = true;
                this.$timeout(() => {
                    this.$scope.wasSuccessful = false;
                }, 3000);
            }, () => {
                this.$scope.hadError     = true;
                this.$scope.errorMessage = '';
            });

        this.$scope.hadError      = false;
        this.$scope.wasSuccessful = true;
    }

}

angular.module('Row52.Views')
       .controller('GotInventoryCtrl', GotInventoryCtrl);